import { renderFramedLines } from "../../ui.js"

export function renderSourceScan(): string {
  return renderFramedLines([
    "We'll scan your current folder for packages and analyze how your design system components",
    "are actually used — so Supernova can prototype with your real code.",
    "",
    "You'll choose which packages to include and review results before anything uploads.",
  ])
}

export function renderDiscoveredPackages(): string {
  return renderFramedLines([
    "Select the packages that contain your design system components.",
    "",
    "Tip: select component libraries only — skip config, SDK, and utility packages.",
  ])
}
